// @ts-nocheck

import { useRouter } from 'vue-router';
import { IUser } from '../../../../zabbix-shared/interfaces/intefaces';
import { backendUrl } from '../../../../zabbix-shared/env';
import api from './ApiService';

const router = useRouter();

export const authService = {
    async login() {
        window.location.href = `${backendUrl}/auth/signin`;
    },
    async logout() {
        window.location.href = `${backendUrl}/auth/signout`;
    },
    async getSilentToken() {
        return (await api.get(`/auth/acquireToken`)).data;
    },
    async getLoggedUser(){
        return (await api.get<IUser>('/users/logged')).data
    }
}